import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '@mui/material';
import { FieldArray, Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import { getAllCategories, publishArticle, updateArticle } from '../../redux/api/blog';
import DefaultField from '../../shared/common/DefaultField';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import DefaultSelect from '../../shared/common/DefaultSelect';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import Snack from '../../shared/common/Snack';
import InputFile from './InputFile';
import PublicationInfo from './PublicationInfo';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import ActionButton from './ActionButton';
import MDEditor from './MDEditor';

const EditPostForm = props => {
    const { handleState, strapiId, articleToEdit, artId, handleUpdate, handlePublished } = props;

    const {id, create_uid} = useSelector(state => state.user.user);
    const { tags, published } = articleToEdit;

    const [articleUpdate, setArticleUpdate] = useState(null);
    const [articlePublished, setArticlePublished] = useState(null);

    const [categories, setCategories] = useState([]);
    const [file, setFile] = useState(null);
    const [mkdContent, setMkdContent] = useState(null);
    const [errorOpen, setErrorOpen] = useState(false);

    // EFFECTS
    useEffect(() => {
        if (categories.length === 0) {
            getCategories(id);
        }
    }, []);

    useEffect(() => {
        if (articleUpdate !== null) {
            handleUpdate(articleUpdate);
        }
        if (articlePublished !== null) {
            handlePublished(articlePublished);
        }
    }, [articlePublished, articleUpdate]);

    // STATE INICIAL
    const initialValues = {
        title: articleToEdit.title || '',
        preview: articleToEdit.preview || '',
        content: articleToEdit.content || '',
        categories: articleToEdit.categories.data.id || '',
        slug: articleToEdit.slug || '',
        tags: tags || [' '],
        cover: articleToEdit.cover?.data.attributes || '',
        is_external: false,
        main_category: articleToEdit.main_category || '',
        company: strapiId,
        author: create_uid[1],
        published: published || '',
        updatedAt: articleToEdit.updatedAt || '',
        publication_date: articleToEdit.publication_date || '',
        createdAt: articleToEdit.createdAt || '',
    };

    // FUNCTIONS

    const getCategories = async repo_id => {
        let req = await getAllCategories(repo_id);
        if (!!req) {
            setCategories(
                req.data.map(categ => ({
                    id: categ.id,
                    name: categ.attributes.name,
                })),
            );
        }
    };

    function handleCloseError() {
        setErrorOpen(false);
    }

    const handleContent = mkdCont => {
        setMkdContent(mkdCont);
    };

    const handleSubmitFile = file => {
        setFile(file);
    };

    const handleSubmit = async values => {
        const data = {
            title: values.title,
            preview: values.preview,
            is_external: false,
            author: create_uid[1],
            content: mkdContent,
            main_category: values.main_category,
            categories: values.categories,
            company: strapiId,
            tags: JSON.stringify(values.tags),
            published: false,
            //la edicion del articulo fuerza su estado de publicado a borrador,
            //si estaba publicado necesariamente debe publicarlo nuevamente tras el update de modificaciones
        };
        const formData = new FormData();
        formData.append('data', JSON.stringify(data) || '');
        formData.append('files.cover', file || '');

        let response = await updateArticle(artId, formData);
        if (response.error) {
            setErrorOpen(true);
            <Snack open={errorOpen} handleClose={handleCloseError} severity="warning" color="#f44336">
                El artículo no pudo actualizarse, favor de contactarse con el administrador.
            </Snack>;
        } else {
            setArticleUpdate(response);
            handleState(response);
        }
    };

    const handlePublish = async () => {
        let response = await publishArticle(artId, { publish: true });
        // console.log('response-publishArticle', response);
        if (response.error) {
            setErrorOpen(true);
            <Snack open={errorOpen} handleClose={handleCloseError} severity="warning" color="#f44336">
                El artículo no pudo publicarse, favor de contactarse con el administrador.
            </Snack>;
        } else {
            setArticlePublished(response);
            handleState(response);
        }
    };

    // console.log('mkdContent', mkdContent)
    // console.log('initialValues', initialValues)

    // RETURN
    return (
        <>
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ values }) => (
                    <FormContainer>
                        <Content>
                            <First>
                                <Row>
                                    <Label>
                                        Título
                                        <DefaultField
                                            name="title"
                                            type="text"
                                            label=""
                                            required
                                            variant="outlined"
                                            placeholder="Ingresa un título"
                                            border="1px solid #616161"
                                            borderradius="8px"
                                        />
                                    </Label>

                                    <Label>
                                        Slug
                                        <DefaultField
                                            name="slug"
                                            type="text"
                                            disabled
                                            variant="outlined"
                                            label=""
                                            placeholder="Campo autogenerado"
                                            border="1px solid #616161"
                                            borderradius="8px"
                                        />
                                    </Label>
                                </Row>
                                <Label>Descripción</Label>
                                <DefaultField
                                    name="preview"
                                    type="text"
                                    variant="outlined"
                                    label=""
                                    required
                                    placeholder="Ingresa una descripción breve "
                                    border="1px solid #616161"
                                    borderradius="8px"
                                />
                            </First>

                            <Second>
                                <Label>Información</Label>
                                <PublicationInfo
                                    author={initialValues.author}
                                    creation={initialValues.createdAt}
                                    update={initialValues.updatedAt}
                                    published={initialValues.published}
                                />
                            </Second>

                            <Third>
                                <Label>Contenido</Label>
                                <MDEditor initialContent={initialValues.content} handleContent={handleContent} />
                            </Third>

                            <Fourth>
                                <Label>Categoría</Label>
                                <DefaultSelect name="categories" placeholder="Selecciona una" options={categories} />
                                <Label>Tags</Label>
                                <FieldArray
                                    name="tags"
                                    render={arrayHelpers => (
                                        <>
                                            {values.tags.map((tag, index) => (
                                                <Row key={index}>
                                                    <DefaultField
                                                        name={`tags.${index}`}
                                                        type="text"
                                                        label=""
                                                        variant="outlined"
                                                        placeholder="Ingresa tags para tu artìculo"
                                                        border="1px solid #616161"
                                                        borderradius="8px"
                                                    />
                                                    <Actions>
                                                        {index !== 0 && <DeleteRoundedIcon onClick={() => arrayHelpers.remove(index)} />}
                                                        <AddRoundedIcon onClick={() => arrayHelpers.insert(index, '')} />
                                                    </Actions>
                                                </Row>
                                            ))}
                                        </>
                                    )}></FieldArray>
                            </Fourth>

                            <Fifth>
                                <Label>Portada</Label>
                                <InputFile initialContent={initialValues.cover} handleSubmitFile={handleSubmitFile} type="edit" />
                            </Fifth>
                        </Content>

                        <ButtonWrapper>
                            {
                                <WrapperButtons>
                                    <ButtonToPublish variant="contained" type="submit" disabled={published} onClick={handlePublish}>
                                        Publicar
                                    </ButtonToPublish>
                                    <ButtonToSave
                                        variant="contained"
                                        type="submit"
                                        disabled={mkdContent === null || file === null}
                                        onClick={handleSubmit}>
                                        Guardar cambios
                                    </ButtonToSave>
                                    <ActionButton
                                        title="Vista previa"
                                        type="submit"
                                        icon={<VisibilityRoundedIcon />}
                                        bgc="var(--secondary-one)"
                                        textColor="var(--primary-one)"
                                        border={"1px solid var(--primary-one)"}
                                        action={`/articulo/${artId}`}
                                    />
                                </WrapperButtons>
                            }
                        </ButtonWrapper>
                    </FormContainer>
                )}
            </Formik>
        </>
    );
};

export default EditPostForm;

const FormContainer = styled(Form)`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const ButtonWrapper = styled.div`
    margin: 1rem 0;
    display: flex;
    gap: 1rem;
`;

const Content = styled.div`
    display: grid;
    grid-template-areas:
        'first second'
        'third fourth'
        'third  fifth';
    gap: 2rem;
    margin-top: 25px;
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
    }
`;

const Label = styled.span`
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: var(--primary-one);
    padding: 0.5rem 0 1rem 0;
`;

const First = styled.div`
    width: calc(100%-64px);
    grid-area: first;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 32px;
    background: #ffffff;
    box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
    border-radius: 20px;
`;

const Second = styled.div`
    grid-area: second;
    width: calc(100%-64px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 32px;
    background: #ffffff;
    box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
    border-radius: 20px;
`;

const Third = styled.div`
    grid-area: third;
    width: calc(100%-64px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 32px;
    background: #ffffff;
    box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
    border-radius: 20px;
`;

const Fourth = styled.div`
    grid-area: fourth;
    width: calc(100%-64px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 32px;
    background: #ffffff;
    box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
    border-radius: 20px;
`;

const Fifth = styled.div`
    grid-area: fifth;
    width: calc(100%-4rem);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    background: #ffffff;
    box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
    border-radius: 20px;
`;

const Row = styled.div`
    display: grid;
    grid-template-columns: 4fr 1fr;
    width: 100%;
    gap: 0.5rem;

    .MuiFormHelperText-root.MuiFormHelperText-contained.Mui-required.MuiFormHelperText-marginDense {
        display: none;
    }
`;

const Actions = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 0;
    justify-content: space-around;
    svg {
        color: var(--secondary-four);
    }
`;

const WrapperButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 0.5rem;
    position: absolute;
    top: -8rem;
    right: 1rem;
`;

const ButtonToPublish = styled(Button)`
    &.MuiButtonBase-root.MuiButton-root {
        background: var(--secondary-one);
        border: 1px solid var(--primary-one);
        color: var(--primary-one);
        padding: 0.75rem 1.5rem;
        gap: 0.5rem;
        width: max-content;
        border-radius: 3rem;
        span {
            font-size: 0.875rem;
            letter-spacing: 0.001em;
            line-height: 1.25rem;
            font-weight: 600;
        }

        &.Mui-disabled {
            background-color: rgba(0, 0, 0, 0.12) !important;
            border: none;
            color: rgba(0, 0, 0, 0.26);
        }
    }
`;

const ButtonToSave = styled(Button)`
    &.MuiButtonBase-root.MuiButton-root {
        background-color: var(--primary-one);
        color: #ffff;
        padding: 0.75rem 1.5rem;
        gap: 0.5rem;
        width: max-content;
        border-radius: 3rem;
        span {
            font-size: 0.875rem;
            letter-spacing: 0.001em;
            line-height: 1.25rem;
            font-weight: 600;
        }
    }
`;
